import { useCallback, useMemo } from 'react'

import { atom, useAtomValue, useSetAtom } from 'jotai'

import { Member } from './entity'

const membersByIdAtom = atom<Record<string, Member>>({})

export const useMembers = () => {
  const byId = useAtomValue(membersByIdAtom)
  return useMemo(() => Object.values(byId), [byId])
}

export const useMember = (uid: string): Member | undefined => {
  const byId = useAtomValue(membersByIdAtom)
  return byId[uid]
}

export const useUpsertMember = () => {
  const set = useSetAtom(membersByIdAtom)
  return useCallback(
    (member: Member) => set(prev => ({ ...prev, [member.uid]: member })),
    [set],
  )
}

export const useReplaceMembers = () => {
  const set = useSetAtom(membersByIdAtom)
  return useCallback(
    (list: Member[]) => set(Object.fromEntries(list.map(m => [m.uid, m]))),
    [set],
  )
}

export const useResetMembers = () => {
  const set = useSetAtom(membersByIdAtom)
  return useCallback(() => set({}), [set])
}
